<template>
  <div>
    <div
      style="min-height: 400px;background-size: cover!important;background-position: center!important;background-repeat: no-repeat!important; background-image: url(&quot;https://ecloud.eos-guangzhou-1.cmecloud.cn/op-node-portal-web/static/images/solution/enterprise/stores/3200.jpg&quot;);">
      <div style="position: relative;width: 50%;margin-left:20%;">
        <div style="padding:5% 0%;font-size: 42px;font-weight: 500;font-height:50px;color: #fff;">
          充电平台解决方案
        </div>
        <div style="font-size: 22px;color: #fff;">
          聚泰云365充电平台为零售门店提供涵盖IT基础设施、大数据、人工智能的全面云服务支撑，围绕消费者购物过程，重构门店人、货、场，帮助门店客户构建全渠道、智能化的新业务形态。
        </div>
      </div>
    </div>
    <div
      style="margin-bottom: 40px;font-size: 28px;line-height: 36px;font-weight: 500;text-align: center;padding-top: 30px;">
      行业需求
    </div>
    <div class="delivery">
      <div class="deliver_parent">
        <div class="delivery_border">
          <div>
            <img class="delivery_border_img" :src="delivery[0].img" />
          </div>
          <div class="delivery_border_title">{{ delivery[0].title }}</div>
          <div class="delivery_border_content">{{ delivery[0].contents[0] }}</div>
        </div>
        <div class="delivery_border">
          <div>
            <img class="delivery_border_img" :src="delivery[1].img" />
          </div>
          <div class="delivery_border_title">{{ delivery[1].title }}</div>
          <div class="delivery_border_content">{{ delivery[1].contents[0] }}</div>
        </div>
        <div class="delivery_border">
          <div>
            <img class="delivery_border_img" :src="delivery[2].img" />
          </div>
          <div class="delivery_border_title">{{ delivery[2].title }}</div>
          <div class="delivery_border_content">{{ delivery[2].contents[0] }}</div>
        </div>
        <div class="delivery_border">
          <div>
            <img class="delivery_border_img" :src="delivery[3].img" />
          </div>
          <div class="delivery_border_title">{{ delivery[3].title }}</div>
          <div class="delivery_border_content">{{ delivery[3].contents[0] }}</div>
        </div>
      </div>
    </div>

    <div
      style="margin-bottom: 40px;font-size: 28px;line-height: 36px;font-weight: 500;text-align: center;padding-top: 30px;">
      方案架构
    </div>
    <div style="min-height: 400px;background-color: #f5f6f8;padding: 10px;">
      <div
        :style="{ width: '80%', margin: '20px 10%', display: 'flex', flexDirection: 'row', backgroundSize: 'cover', backgroundImage: 'url(' + require('../../static/other/graphic.09c71ea5.jpg') + ')' }">
        <div style="margin: 10px;display: flex;">
          <div style="width: 50%;background-color: #fff;">
            <img style="max-width: 100%;" :src="leftImg" />
          </div>
          <div style="width: 50%;">
            <div style="padding: 16px 16px 16px 32px;">
              <h4 style="font-size: 18px;line-height: 26px;font-weight: 500;color: #181818;">功能特性</h4>
              <div style="padding-top: 20px;">
                <h4 style="padding-bottom: 15px;font-size: 14px;line-height: 22px;font-weight: 500;color: #181818;">
                  用户数字化运营
                </h4>
                <div>
                  <span style="font-size: 14px;color: #181818;">以人脸识别技术为基础对进店顾客进行大数据分析和实现个性化营销推荐
                    。全新客户体系，采集客户数据信息，实时进行多维度统计分析。</span>
                </div>
              </div>
              <div style="padding-top: 20px;">
                <h4 style="padding-bottom: 15px;font-size: 14px;line-height: 22px;font-weight: 500;color: #181818;">
                  产品+服务提升用户体验</h4>
                <div>
                  <span
                    style="font-size: 14px;color: #181818;">利用数字技术随时捕捉全面全域信息感知消费需求，完成供需评估与即时互动。提供满足每个客户个性化需求的商品和服务，从而提升用户体验。</span>
                </div>
              </div>
              <div style="padding-top: 20px;">
                <h4 style="padding-bottom: 15px;font-size: 14px;line-height: 22px;font-weight: 500;color: #181818;">
                  线上线下深度融合科学化管理</h4>
                <div>
                  <span
                    style="font-size: 14px;color: #181818;">所有场景数据化，与原有的数据进行融合。线下门店技术升级，通过数字化技术搭建智慧中台，打通实体与虚拟各个环节，时刻掌握门店信息。</span>
                </div>
              </div>
              <div style="padding-top: 20px;">
                <h4 style="padding-bottom: 15px;font-size: 14px;line-height: 22px;font-weight: 500;color: #181818;">
                  最后一公里的服务能力</h4>
                <div>
                  <span
                    style="font-size: 14px;color: #181818;">门店业务落地，需要工勘、线路、安装、售后等全流程的软硬件服务体系支撑，相比互联网厂家，移动强大的销服体系可以为商铺客户提供更好的用户体验。</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div
      style="margin-bottom: 40px;font-size: 28px;line-height: 36px;font-weight: 500;text-align: center;padding-top: 30px;">
      应用场景
    </div>

    <div
      style="background-color: #f5f6f8;display: flex;flex-direction: row;align-items: stretch;justify-content: center;">
      <div
        style="width: 1200px;display: flex;flex-direction: row;justify-content: space-evenly;align-items: center ;flex-wrap: wrap;">
        <div style="width: 33.33%;padding: 10px;">
          <div
            style="background-color: #fff;height: 100%;min-height: 260px;border-radius: 2px;border: 1px solid #efefef;">
            <div
              style="height: 90px;width: 100%;background-size: cover;background-repeat: no-repeat; background-image: url(&quot;https://ecloud.eos-guangzhou-1.cmecloud.cn/op-node-portal-web/static/images/solution/enterprise/stores/scenario1.png&quot;);">
            </div>
            <div>
              <div style="padding: 16px 16px 16px 32px;">
                <h4 style="font-size: 18px;line-height: 26px;font-weight: 500;">远程巡店</h4>
                <p style="margin-top: 16px;margin-bottom: 10px;font-size: 14px;line-height: 22px;color: #6e6e6e;">
                  负责人使用视频巡店，对员工着装、商品布置、财务、环境等进行全面巡查管理，并将巡店问题下发对应营业厅店长或店员进行及时整改。
                </p>
              </div>
            </div>
          </div>
        </div>
        <div style="width: 33.33%;padding: 10px;">
          <div style="background-color: #fff;min-height: 260px;border-radius: 2px;border: 1px solid #efefef;">
            <div
              style="height: 90px;width: 100%;background-size: cover;background-repeat: no-repeat; background-image: url(&quot;https://ecloud.eos-guangzhou-1.cmecloud.cn/op-node-portal-web/static/images/solution/enterprise/stores/scenario1.png&quot;);">
            </div>
            <div>
              <div style="padding: 16px 16px 16px 32px;">
                <h4 style="font-size: 18px;line-height: 26px;font-weight: 500;">安全看店</h4>
                <p style="margin-top: 16px;margin-bottom: 10px;font-size: 14px;line-height: 22px;color: #6e6e6e;">
                  在库房等重点部位，部署入侵检测，按时段布防，无人状态下对店铺进行安全防范。一旦有人闯入触发告警，通过短信、APP消息及时通知负责人。支持按照场景、时间段进行一键布防\撤防。
                </p>
              </div>
            </div>
          </div>
        </div>
        <div style="width: 33.33%;padding: 10px;">
          <div style="background-color: #fff;min-height: 260px;border-radius: 2px;border: 1px solid #efefef;">
            <div
              style="height: 90px;width: 100%;background-size: cover;background-repeat: no-repeat; 
            background-image: url(&quot;https://ecloud.eos-guangzhou-1.cmecloud.cn/op-node-portal-web/static/images/solution/enterprise/stores/scenario2.png&quot;);">
            </div>
            <div>
              <div style="padding: 16px 16px 16px 32px;">
                <h4 style="font-size: 18px;line-height: 26px;font-weight: 500;">会员系统</h4>
                <p style="margin-top: 16px;margin-bottom: 10px;font-size: 14px;line-height: 22px;color: #6e6e6e;">
                  通过录入脸库，会员到店自动识别并标注，实现基于会员的精准营销。支持统计常客到店次数，助力常客转化，提高顾客留存率和单店坪效。
                </p>
              </div>
            </div>
          </div>
        </div>
        <div style="width: 33.33%;padding: 10px;">
          <div style="background-color: #fff;min-height: 290px;border-radius: 2px;border: 1px solid #efefef;">
            <div
              style="height: 90px;width: 100%;background-size: cover;background-repeat: no-repeat;
              background-image: url(&quot;https://ecloud.eos-guangzhou-1.cmecloud.cn/op-node-portal-web/static/images/solution/enterprise/stores/scenario3.png&quot;);">
            </div>
            <div>
              <div style="padding: 16px 16px 16px 32px;">
                <h4 style="font-size: 18px;line-height: 26px;font-weight: 500;">客流统计</h4>
                <p style="margin-top: 16px;margin-bottom: 10px;font-size: 14px;line-height: 22px;color: #6e6e6e;">
                  进店顾客自动抓拍建档，设置标签如会员、高频客户、高消费客户、偷窃嫌疑人等，可设置指定客户到店时自动提醒。按不同周期统计过店、进店客流的数量、性别、特征、各时段变化趋势、会员活跃度、节假日客流特点等。
                </p>
              </div>
            </div>
          </div>
        </div>
        <div style="width: 33.33%;padding: 10px;">
          <div style="background-color: #fff;min-height: 290px;border-radius: 2px;border: 1px solid #efefef;">
            <div
              style="height: 90px;width: 100%;background-size: cover;background-image: url(&quot;https://ecloud.eos-guangzhou-1.cmecloud.cn/op-node-portal-web/static/images/solution/enterprise/stores/scenario5.png&quot;);">
            </div>
            <div>
              <div style="padding: 16px 16px 16px 32px;">
                <h4 style="font-size: 18px;line-height: 26px;font-weight: 500;">店厅管理</h4>
                <p style="margin-top: 16px;margin-bottom: 10px;font-size: 14px;line-height: 22px;color: #6e6e6e;">
                  支持管理员记录店铺档案，包括店铺名称、店铺地址等； 支持对不同店厅设置店长和店员；采集人脸照片，创建员工人脸库
                </p>
              </div>
            </div>
          </div>
        </div>
        <div style="width: 33.33%;padding: 10px;">
          <div style="background-color: #fff;min-height: 290px;border-radius: 2px;border: 1px solid #efefef;">
            <div
              style="height: 90px;width: 100%;background-size: cover;background-repeat: no-repeat; background-image: url(&quot;https://ecloud.eos-guangzhou-1.cmecloud.cn/op-node-portal-web/static/images/solution/enterprise/stores/scenario6.png&quot;);">
            </div>
            <div>
              <div style="padding: 16px 16px 16px 32px;">
                <h4 style="font-size: 18px;line-height: 26px;font-weight: 500;">智能商贸推荐（敬请期待）</h4>
                <p style="margin-top: 16px;margin-bottom: 10px;font-size: 14px;line-height: 22px;color: #6e6e6e;">
                  以运营商网络信令轨迹链信息为核心、融合空间地理信息及空间运算能力，得到更精确的用户画像，并结合企业自身数据、互联网数据、城市规划、周边人流、人群等数据，通过大数据和AI算法手段进行融合分析，提供权威、精确的大数据决策辅助。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div
      style="display: flex;flex-direction:column;justify-content: center;align-items: center ;background-position: 50%;background-repeat: no-repeat;height: 100%; background-image: url(&quot;https://ecloud.eos-guangzhou-1.cmecloud.cn/op-node-portal-web/static/images/common/case-background.jpg&quot;);">


      <div
        style="margin-bottom: 40px;font-size: 28px;line-height: 36px;font-weight: 500;text-align: center;padding-top: 30px;">
        客户案例
      </div>

      <div style="width: 1200px;padding-bottom: 20px;">
        <div style="background-color: #fff;">
          <div style="padding: 40px 32px 40px 24px;display: flex;">
            <div style="width: 50%;">
              <div style="padding: 16px 16px 16px 32px;">
                <h4>中国移动新零售营业厅</h4>
                <p style="margin-top: 16px;margin-bottom: 10px;font-size: 14px;line-height: 22px;color: #6e6e6e;">
                  已在江苏省和浙江省五十多家移动营业厅部署，通过AI摄像机、智能人脸分析终端、鱼眼摄像机等设备，对进店人群进行人脸抓拍识别，根据多维数据分析，实现客户身份识别、门店客流统计、热区分析等功能，可实时识别出每个到店客户的身份信息，还可对频繁到店或有异常行为的人员进行甄别和告警，达到针对会员客户精准营销、针对异常人员及时告警处理防止进店的目的。帮助营业厅门店提升了管理效率、门店营收以及应对异常人员情况的能力。
                </p>
              </div>
            </div>
            <div style="width: 50%;">
              <img style="max-width: 100%;" :src="case1" />
            </div>
          </div>
        </div>
        <div style="background-color: #f6f7fa;">
          <div style="padding: 40px 32px 40px 24px;display: flex;">
            <div style="width: 50%;">
              <img style="max-width: 100%;" :src="case2" />
            </div>
            <div style="width: 50%;">
              <div style="padding: 16px 16px 16px 32px;">
                <h4>某品牌商场</h4>
                <p style="margin-top: 16px;margin-bottom: 10px;font-size: 14px;line-height: 22px;color: #6e6e6e;">
                  利用人脸识别技术赋能商场管理，从入口客流、楼层客流到商户客流，进行多维度数据分析，丰富商场科学运营手段。对各个商铺的到店人数进行统计分析，辅助商场进行各商铺定价。自定义时间和区域，查询活动期间、活动区域的人流情况，以此作为评估、优化活动的数据支撑。
                </p>
              </div>
            </div>
          </div>
        </div>
        <div style="background-color: #fff;">
          <div style="padding: 40px 32px 40px 24px;display: flex;">
            <div style="width: 50%;">
              <div style="padding: 16px 16px 16px 32px;">
                <h4>某品牌4S店</h4>
                <p style="margin-top: 16px;margin-bottom: 10px;font-size: 14px;line-height: 22px;color: #6e6e6e;">
                  该方案以人脸识别为核心为某品牌汽车100多家4S店提供巡店、用户识别、告警等等功能，首先对门店进行人流统计分析，包括对年龄层次，性别比例等多维度进行统计分析，更直接反馈于管理者客户倾向。针对巡店问题，可实时线上记录，生成巡店报告，并可以发送至指定负责人进行解决，解决完毕之后可关闭问题。并由此为基准点提升4S店的管理与服务质量。
                </p>
              </div>
            </div>
            <div style="width: 50%;">
              <img style="max-width: 100%;" :src="case3" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Mysales',
  data() {
    return {
      background: '../../static/other/graphic.09c71ea5.jpg',
      leftImg: require('../../static/other/stores-frame1.png'),
      case1: require('../../static/other/case1.png'),
      case2: require('../../static/other/case2.png'),
      case3: require('../../static/other/case3.png'),
      delivery: [
        {
          img: require('../../static/other/fanganzixun.png'),
          title: "方案咨询",
          contents: ["为客户提供信息化、数字化、一体化的业务运营管理平台的解决方案，并进行定制化的服务"]
        },
        {
          img: require('../../static/other/xitongyanfa.png'),
          title: "系统研发&集成",
          contents: ["信息化软硬件项目和系统集成类项目的合作研发，自主研发；客户定制化开发等项目合作"]
        },
        {
          img: require('../../static/other/shishipeixun.png'),
          title: "实施培训",
          contents: ["为产品的顺利上线部署保驾护航，依据实际业务需求为客户提供高品质的实施方案及计划"]
        },
        {
          img: require('../../static/other/xitongyunwei.png'),
          title: "运维服务",
          contents: ["为后期业务展开提供技术保障，为客户提供产品版本的迭代升级，与客户保持良性的合作关系，互惠互利。"]
        },
        {
          img: require('../../static/other/disanfangceshi.png'),
          title: "第三方测试",
          contents: ["为产品的质量保驾护航，对产品进行多层次、多视角、多平台等完整的实体业务测试，来保证产品交付质量。"]
        },
        {
          img: require('../../static/other/itjianli.png'),
          title: "IT监理",
          contents: ["专业的IT监理团队，为各企业进行IT方面的监理工作，保证产品的品质和工作效率。"]
        }
      ]
    }
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.delivery_border {
  height: auto;
  margin: 10px;
  width: 55%;
  text-align: center;
  /*border-radius: 6px;*/
  /*border: 1px solid #EBEEF5;*/
}

.delivery_border_img {
  margin-top: 20px;
  width: 70px;
  height: 70px;
}

.delivery_border_title {
  margin-top: 10px;
  font-size: 18px;
  font-weight: normal;
  color: #000000e6;
}

.delivery_border_content {
  margin-top: 10px;
  font-size: 14px;
  text-align: left;
  font-weight: normal;
  color: #0009;
}

.fruit_img {
  height: 550px;
  width: 100%;
}

.fruit_product_img {
  height: 500px;
  width: 260px;
}

.deliver_parent {
  width: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.deliver_img_parent {
  width: 30%;
  height: auto;
}

.delivery {
  display: flex;
  /* height: 550px; */
  width: 90%;
  margin: auto;
  justify-content: center;
  align-items: center;
}

/* 屏幕设备适配 max-device-width: 400px */
@media screen and (max-device-width: 415px) {
  .fruit_img {
    height: 250px;
    width: 100%;
  }

  .fruit_product_img {
    height: 400px;
    width: 240px;
  }

  .delivery_border_img {
    margin-top: 20px;
    width: 70px;
    height: 70px;
  }

  .deliver_img_parent {
    width: 100%;
    float: left;
    height: 400px;
  }

  .deliver_parent {
    float: left;
    margin-top: 5px;
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
  }

  .delivery_border {
    height: auto;
    margin: 10px 0 auto;
    width: 100%;
    float: right;
    border-radius: 6px;
    border: 1px solid #EBEEF5;
  }

  .delivery {
    display: flex;
    width: 90%;
    height: auto;
    margin: auto;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .delivery_border_title {
    margin-top: 5px;
    font-size: 1.125em;
    font-weight: normal;
  }

  .delivery_border_content {
    margin-top: 5px;
    font-size: 1.125em;
    font-weight: normal;
    margin-bottom: 10px;
  }
}
</style>